import { Injectable } from '@angular/core';
import { Observable, finalize, of, shareReplay, tap } from 'rxjs';
import { Empty } from '@ngx-grpc/well-known-types';
import { AuthService } from '../../authentication/service/auth.service';
import { GetMainDashboardDataResponse } from '../../protos/generated/admin.pb';
import { ReportServiceEndpointClient } from '../../protos/generated/admin.pbsc';

@Injectable({
    providedIn: 'root'
})
export class B2bDashboardService {
    private cachedResponse: {
        key: string;
        data: GetMainDashboardDataResponse;
    } | null = null;

    private inFlightRequest$: Observable<GetMainDashboardDataResponse> | null = null;
    private inFlightRequestKey: string | null = null;

    constructor(
        private readonly reportClient: ReportServiceEndpointClient,
        private readonly authService: AuthService
    ) { }

    getMainDashboardData(
        forceRefresh = false
    ): Observable<GetMainDashboardDataResponse> {

        const cacheKey = this.getCacheKey();

        if (
            !forceRefresh &&
            this.cachedResponse &&
            this.cachedResponse.key === cacheKey
        ) {
            return of(this.cachedResponse.data);
        }

        if (
            !forceRefresh &&
            this.inFlightRequest$ &&
            this.inFlightRequestKey === cacheKey
        ) {
            return this.inFlightRequest$;
        }

        const metadata = this.authService.getMetadata();

        const request$ = this.reportClient
            .getMainDashboardData(new Empty(), metadata)
            .pipe(
                tap(response => {
                    this.cachedResponse = {
                        key: cacheKey,
                        data: response
                    };
                }),
                finalize(() => {
                    if (this.inFlightRequest$ === request$) {
                        this.inFlightRequest$ = null;
                        this.inFlightRequestKey = null;
                    }
                }),
                shareReplay({ bufferSize: 1, refCount: false })
            );

        this.inFlightRequest$ = request$;
        this.inFlightRequestKey = cacheKey;
        return request$;
    }

    clearCache(): void {
        this.cachedResponse = null;
        this.inFlightRequest$ = null;
        this.inFlightRequestKey = null;
    }

    private getCacheKey(): string {
        const token = this.authService.getToken();

        return token ?? '';
    }
}
